const topics = [
  { tag: '网红塌房', heat: '98.6万', trend: 'up', color: 'bg-primary-100 text-primary-700' },
  { tag: '网曝门', heat: '87.3万', trend: 'hot', color: 'bg-accent-100 text-accent-900' },
  { tag: '明星爆料', heat: '76.2万', trend: 'up', color: 'bg-primary-100 text-primary-700' },
  { tag: '博主反差', heat: '65.9万', trend: 'new', color: 'bg-secondary-100 text-secondary-900' },
  { tag: '每日大赛', heat: '58.4万', trend: 'hot', color: 'bg-accent-100 text-accent-900' },
  { tag: '黑料合集', heat: '52.1万', trend: 'up', color: 'bg-primary-100 text-primary-700' },
  { tag: '吃瓜一线', heat: '47.8万', trend: 'hot', color: 'bg-accent-100 text-accent-900' },
  { tag: '反差视频', heat: '43.5万', trend: 'new', color: 'bg-secondary-100 text-secondary-900' },
  { tag: '塌房现场', heat: '38.9万', trend: 'up', color: 'bg-primary-100 text-primary-700' },
  { tag: '扒皮深挖', heat: '34.6万', trend: 'hot', color: 'bg-accent-100 text-accent-900' },
];

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  hot: 'ri-fire-line',
  new: 'ri-sparkling-line',
};

export default function Topics() {
  return (
    <section id="topics" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            热门话题
          </h2>
          <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full whitespace-nowrap">
            Trending
          </span>
        </div>
        <div className="flex flex-wrap gap-3">
          {topics.map((topic) => (
            <a
              key={topic.tag}
              href="#"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full ${topic.color} text-sm font-medium hover:opacity-80 transition-opacity duration-200 cursor-pointer whitespace-nowrap`}
            >
              <span>{topic.tag}</span>
              <span className="text-xs opacity-70">{topic.heat}</span>
              <i className={`${trendIcons[topic.trend]} text-xs`}></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}